<mbm-modal id="confirmation-modal" [titleKey]="titleKey" (modalClose)="onCancel()">
  <ng-container slot="modal-content">
    <div class="confirmation-content">
      @if (subtitleKey) {
        <p id="confirmation-subtitle" class="confirmation-subtitle">{{ subtitleKey | translate }}</p>
      }
      <p id="confirmation-message" class="confirmation-message">{{ messageKey | translate: messageParams }}</p>
    </div>
  </ng-container>

  <ng-container slot="modal-footer">
    <div class="confirmation-actions">
      @if (!hideCancel) {
        <mbm-button id="confirmation-cancel-btn" variant="outline" [textKey]="cancelTextKey" (buttonClick)="onCancel()"></mbm-button>
      }
      <mbm-button id="confirmation-confirm-btn" [variant]="confirmVariant" [textKey]="confirmTextKey" (buttonClick)="onConfirm()"></mbm-button>
    </div>
  </ng-container>
</mbm-modal>
